/**
 * HDFC SmartGateway (JusPay) — Payment initiation helper.
 *
 * Saves the full pending booking state to sessionStorage, then redirects
 * the browser to the HDFC hosted payment page. On return, PaymentCallback
 * reads that saved state and completes the booking.
 */

export const initiateHDFCPayment = async ({
  createHDFCSessionFn,
  amount,
  patientId,
  bookingPayload,
  booking_type,
  consultationFee,
}) => {
  const returnUrl = `${window.location.origin}/payment/callback`;

  // Persist everything needed to complete the booking after redirect
  const pendingState = {
    patientId,
    bookingPayload,
    booking_type,
    consultationFee,
  };
  sessionStorage.setItem("hdfcPendingBooking", JSON.stringify(pendingState));

  const patient = (() => {
    try {
      return JSON.parse(localStorage.getItem("patient") || "{}");
    } catch {
      return {};
    }
  })();

  const sessionRes = await createHDFCSessionFn({
    amount,
    patient_id: String(patientId),
    return_url: returnUrl,
    description:
      process.env.REACT_APP_PAY_DESCRIPTION || "OP Consultation Charges",
    customer_name:
      `${patient.firstName || ""} ${patient.lastName || ""}`.trim() ||
      "Patient",
    customer_email: patient.email || "noreply@hospital.com",
    customer_phone: patient.phoneNumber || "0000000000",
  });

  if (!sessionRes?.paymentPageUrl) {
    throw new Error("HDFC payment page URL was not received from the server.");
  }

  // Redirect browser to HDFC hosted payment page
  window.location.href = sessionRes.paymentPageUrl;
};
